import type { userUpdateDTOSchema } from '@tempo-io/id-dto';
import { parseResponse } from 'hono/client';
import type { z } from 'zod';
import { getIdApi } from '../id/getIdApi';

export const getCurrentUserProfile = async () => {
  const api = getIdApi();
  return parseResponse(api.profile.v1.$get());
};

export const getPasswordChangeTicket = async () => {
  const api = getIdApi();
  return parseResponse(api.profile.v1['change-password-ticket'].$post({ json: { client: 'id' } }));
};

export type AvatarFileType =
  | 'image/png'
  | 'image/jpeg'
  | 'image/webp'
  | 'image/avif'
  | 'image/gif'
  | 'image/svg+xml';

export const getProfilePictureUploadUrl = async ({
  type,
  contentLength,
}: {
  type: AvatarFileType;
  contentLength: number;
}) => {
  const api = getIdApi();
  return parseResponse(
    api.profile.v1['picture-upload-url'].$post({ json: { type, contentLength } }),
  );
};

export const updateUserProfile = async (data: z.input<typeof userUpdateDTOSchema>) => {
  const api = getIdApi();
  return parseResponse(api.profile.v1.$patch({ json: data }));
};
